import { BreakPointCondition, useBreakpointIf, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { OrderHeaderDetailsLoading } from '../../../OrderHistoryModal/components/OrderHeaderDetailsLoading';
import { OrderPrincipalCardDetailsLoading } from '../../../OrderHistoryModal/components/OrderPrincipalCardDetailsLoading';
import { OrderStatusesSequence } from '../../../OrderHistoryModal/components/OrderStatusesSequence';
import { OrderAccordionLoading } from '../OrderAccordionLoading';

export interface BatchDetailsLoadingProps {
  handleCloseDetails: () => void;
}

export const BatchDetailsLoading: React.FC<BatchDetailsLoadingProps> = ({ handleCloseDetails }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  return (
    <VStack
      flex="1"
      padding={Spacing['inline.xxs']}
      space={Spacing['stack.xxxs']}
      bgColor={Color['neutral.white']}
      overflowY="scroll">
      <OrderHeaderDetailsLoading onClose={handleCloseDetails} isBasket isMobile={isMobile} />
      <OrderPrincipalCardDetailsLoading isBasket isMobile={isMobile} />
      <OrderStatusesSequence isMobile={isMobile} />
      <OrderAccordionLoading quantity={2} isMobile={isMobile} />
    </VStack>
  );
};
